export default function Marquee({ items, className = "" }) {
  const row = [...items, ...items];
  return (
    <div
      data-testid="capability-marquee"
      className={`relative overflow-hidden border-y border-line bg-panel ${className}`}
      aria-label={items.join(", ")}
    >
      <div className="flex w-max animate-marquee whitespace-nowrap py-5" aria-hidden="true">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center font-mono text-xs md:text-sm tracking-[0.25em] uppercase text-zinc-400"
          >
            <span className="px-8">{item}</span>
            <span className="text-signal">//</span>
          </span>
        ))}
      </div>
    </div>
  );
}
